// The floor the budget input enforces while the operator is still editing.
// Needed to recompute the minimum total budget floor based on the current runtime inputs.
export function minTotalBudgetFloor({ minBudget, minDailyBudget, platforms, days }) {
  const runtimeDays = days > 0 ? days : 1
  const platformMinima = (platforms || []).map((platform) => platform.min_daily_budget || 0)
  // The event total is split evenly across active platforms, so clearing the
  // strictest platform's own daily minimum takes platformCount times as much.
  const dailyFloor = platformMinima.length
    ? Math.max(...platformMinima) * platformMinima.length
    : minDailyBudget || 0

  return Math.max(minBudget || 0, dailyFloor * runtimeDays)
}
